import React, { FormEvent, useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import useApi from '../../hooks/useApi'
import { SubmitButton } from '../../Korbantech/components/Buttons/SubmitButton'
import { AdminLayout } from '../../layout/AdminLayout'
import { Trail } from '../../types/Trail'
import { HeaderPage } from '../HeaderPage'
import { Modules } from './Modules'
import { NameFields } from './NameFields'


export const TrailsForm = () => {

  const navigate = useNavigate()
  const api = useApi()

  const [trail,setTrail] = useState< Trail | undefined >()

  const {id} = useParams<any>()

  const loadTrail = useCallback(async()=>{
    if(id)
    return await api.get(`/admin/trails/${id}`).then( res => {
        setTrail(res.data);
    })

    return setTrail(undefined)
  },[api , id ])

  const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
       
    e.preventDefault()
    e.currentTarget.checkValidity()

    if (!e.currentTarget) return
    const data = new FormData(e.currentTarget)

    return await api.post(`/admin/trails`, data).then(res => {
         navigate("/admin/trilha");
    }).catch(console.log)

}, [api, navigate])

useEffect(()=>{
  loadTrail()
},[loadTrail])

return(
      <AdminLayout>
        <HeaderPage name='Nova trilha' />
         <div className='flex w-full justify-center'>
            <div className='w-6/12 bg-white rounded-md border-2 border-gray-200 p-3'>
              <div className='text-lg font-bold'>
                Cadastrar Trilha 
              </div>
              {!trail && <form onSubmit={handleSubmit} className="">
                  <NameFields />
                  <Modules />
                  <SubmitButton value={"Salvar trilha"}/>                 
              </form>}
              {trail && 
              <div>
                  <NameFields trail={trail} />
                  <Modules modules={trail?.modules}/>
              </div>
              }
              
            </div>
         </div>
      </AdminLayout>
    )
}